import React, { useEffect } from "react";
import { Typography, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../App.css";
import { BookingApi } from "../../API/Apis/BookingApi";
import i18n from "i18next";
import WebCheckInLayout from "./WebCheckInLayout";
import { GoCheckCircle } from "react-icons/go";
import BookingGetters from "../../store/onlineBooking/getters";

type Props = {
  reservationDetails: any;
  onBack: () => void;
  onNext?: () => void;
  isSmallScreen: boolean;
  progress: any;
  onConfirmed?: (success: boolean) => void;
  isShareboxEnabled?: boolean;
};

const styles = {
  webCheckInText: (isSmallScreen: boolean) => ({
    color: "#19344FCC",
    fontWeight: 700,
    fontSize: isSmallScreen ? "17px" : "21px",
    lineHeight: "100%",
    textAlign: "center",
    mt: 2,
  }),
  webCheckInSubtext: (isSmallScreen: boolean) => ({
    fontWeight: 700,
    lineHeight: "100%",
    color: "#19344FCC",
    textAlign: "center",
    fontSize: isSmallScreen ? "16px" : "21px",
    mb: "5px",
    mt: "6px",
  }),
};

function WebCheckCompletionPage({
  reservationDetails,
  onBack,
  onNext,
  isSmallScreen,
  progress,
  onConfirmed,
  isShareboxEnabled,
}: Props) {
  const { t: translate } = useTranslation();
  const language = i18n.language;
  const id = localStorage.getItem("userID");

  useEffect(() => {
    if (reservationDetails) {
      BookingApi.sendEmailForWireTransfer(
        reservationDetails.reservationId,
        "webCheckinEmail",
        language,
        id || ""
      )
        .then(() => {})
        .catch((err) => console.error("Failed to send email:", err));

      BookingApi.webCheckinConfirmation(
        reservationDetails.reservationId,
        "webCheckinConfirmation",
        language
      )
        .then((response) => {
          const success = response?.data?.data?.status === true;
          if (success) {
            console.log(
              "Web check-in confirmation PASSED:",
              reservationDetails.reservationId,
              response?.data
            );
          } else {
            console.error(
              "Web check-in confirmation FAILED (unsuccessful response):",
              reservationDetails.reservationId,
              response?.data
            );
          }
          onConfirmed?.(success);
        })
        .catch((err) => {
          console.error(
            "Web check-in confirmation FAILED:",
            reservationDetails.reservationId,
            err
          );
          onConfirmed?.(false);
        });
    }
  }, [reservationDetails, language, id]);

  const appSettings = BookingGetters.getAppSettings();
  const Circle = GoCheckCircle as React.ElementType;
  const webCheckinHeaderBgColor = appSettings?.webCheckinHeaderBgColor;

  return (
    <WebCheckInLayout
      title={translate("WEB CHECK IN COMPLETED")}
      progress={progress}
      onBack={onBack}
    >
      <Box className="success-icon-container">
        <Circle
          className="success-icon"
          style={{ color: webCheckinHeaderBgColor || "#2cb133" }}
        />{" "}
      </Box>

      <Typography variant="h5" sx={styles.webCheckInText(isSmallScreen)}>
        {translate("Congratulations!")}
      </Typography>

      <Typography variant="h5" sx={styles.webCheckInSubtext(isSmallScreen)}>
        {translate("Your web check-in was successful.")}
      </Typography>

      {!isShareboxEnabled && (
        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            onClick={onNext}
            className="webCheckInButton"
            style={{
              borderRadius: `${appSettings?.buttonBorderRadius || 55}px`,
            }}
          >
            {translate("Close")}
          </Button>
        </Box>
      )}
    </WebCheckInLayout>
  );
}

export default React.memo(WebCheckCompletionPage);
